import React from "react";

const CallToActionOne = ({ extraClassName, buttonClass }) => {
  return (
    <section className="commonSection ready gradient">
      <div className="container">
        <div className="row">
          <div className="col-lg-9 col-sm-8 col-md-9">
            <h2 className="sec_title black">Let's Get Your Project Started!</h2>
          </div>
          <div className="col-lg-3  col-sm-4 col-md-3 text-right">
            <a href="/contact">
              <a className={`common_btn red_bg ${buttonClass}`}>
                <span>Connect with us</span>
              </a>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToActionOne;
